import keyMirror from 'keymirror';

export default keyMirror({
  hold: null,
  hold_released: null,
  cancelled: null,
});
